const ORDINAL_SUFFIXES: Record<string, true> = { st: true, nd: true, rd: true, th: true };
const GO_DOMAIN = "https://go.fergmar.com";

export function buildShortSlug(addressStreet1: string): string {
	return addressStreet1
		.trim()
		.split(/\s+/)
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join("");
}

export function tokenizeShortSlug(shortSlug: string): string[] {
	const rawTokens = shortSlug
		.trim()
		.split(/(?<=[a-z])(?=[A-Z])|(?<=[A-Za-z])(?=\d)|(?<=\d)(?=[A-Za-z])/u)
		.filter(Boolean);
	const tokens: string[] = [];

	for (let i = 0; i < rawTokens.length; i += 1) {
		const token = rawTokens[i];
		if (
			/^\d+$/.test(token) &&
			rawTokens[i + 1] &&
			ORDINAL_SUFFIXES[rawTokens[i + 1].toLowerCase()]
		) {
			tokens.push(`${token}${rawTokens[i + 1]}`);
			i += 1;
		} else {
			tokens.push(token);
		}
	}

	return tokens;
}

export function buildShortUrl(addressStreet1: string): string {
	return `${GO_DOMAIN}/for-sale/${buildShortSlug(addressStreet1)}`;
}
